import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { LoginModalPage } from '../login-modal/login-modal.page';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserApiService } from '../services/user-api.service';
import { UserQrPage } from '../user-qr/user-qr.page';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.page.html',
  styleUrls: ['./offers.page.scss'],
})
export class OffersPage implements OnInit {
  helper: any=[]
  rewardItems=[]
  loading: any;
  isLoggedIn=false;
  rewardsSlides=[];

  constructor(public globals:GlobalVariable,
    public server:UserApiService,
    private loadingCtrl:LoadingController,
    private localStorageService:LocalStorageService,
    private router:Router,
    private modalController:ModalController,
    private nav:NavController

    ) {
    
     }

  ngOnInit() {
  }
  ionViewWillEnter(){
    let login = JSON.parse(this.localStorageService.getLogin('isLogin'))
    if(login!=null){
      this.isLoggedIn=login;
      console.log('LoggedIn',this.isLoggedIn)
    }
    this.point_items();
    this.rewardsBanners()
  }
  goTo(){
    if(this.isLoggedIn){
      this.nav.navigateRoot('/my-rewards')

    }
    else{
      this.globals.loginmodal()
    }
  }
  
  point_items() {
    this.globals.loader();

    this.sortingArray();

    let response = this.server.getpoints_menuitems();
    response.subscribe(data => {
      this.globals.dismiss()
      console.log(data)
      if (data.status == true) {
        this.rewardItems = data.items;
        this.rewardItems.forEach(subelement => {
          subelement.quantity = 1;
          var result = subelement.point_price.replace(/,/g, "");
          subelement.rmstring = parseInt(result);
          if (Number(result) > Number(this.globals.points_)) {
            subelement.disable_btn = true;
          } else {
            subelement.disable_btn = false;
          }
          // console.log(this.rewardItems)
        });
        this.helper.arr.multisort(this.rewardItems, ['rmstring'], ['ASC']);

  
      }

    }
      , error => {
        // loading.dismiss();
      this.globals.dismiss()

        this.globals.presentToast("Something went wrong check your internet connection.")
      });
  }
  sortingArray() {
    this.helper.arr = {

      multisort: function (arr, columns, order_by) {
        if (typeof columns == 'undefined') {
          columns = []
          for (var x = 0; x < arr[0].length; x++) {
            columns.push(x);
          }
        }

        if (typeof order_by == 'undefined') {
          order_by = []
          for (x = 0; x < arr[0].length; x++) {
            order_by.push('ASC');
          }
        }

        function multisort_recursive(a, b, columns, order_by, index) {
          var direction = order_by[index] == 'DESC' ? 1 : 0;

          var is_numeric = !isNaN(a[columns[index]] - b[columns[index]]);

          var x = is_numeric ? a[columns[index]] : a[columns[index]].toLowerCase();
          var y = is_numeric ? b[columns[index]] : b[columns[index]].toLowerCase();

          if (!is_numeric) {
            x = this.helper.string.to_ascii(a[columns[index]].toLowerCase(), -1),
              y = this.helper.string.to_ascii(b[columns[index]].toLowerCase(), -1);
          }

          if (x < y) {
            return direction == 0 ? -1 : 1;
          }

          if (x == y) {
            return columns.length - 1 > index ? multisort_recursive(a, b, columns, order_by, index + 1) : 0;
          }

          return direction == 0 ? 1 : -1;
        }

        return arr.sort(function (a, b) {
          return multisort_recursive(a, b, columns, order_by, 0);
        });
      }
    }

  }
  learnMore(){
    this.router.navigate(['/business-details']);

  }
  // async pageLoading() {
  //   this.loading = await this.loadingCtrl.create({

  //     message: '<img src="assets/animation/loader2.svg" alt="loading...">',
  //     cssClass: 'custom_loading',

  //     // showBackdrop: false,
  //     // spinner: 'hide',
  //   })
  //   await this.loading.present();
  // }



  rewardsBanners(){
    this.server.rewardsSlides().subscribe(res=>{
      console.log(res);
      if(res.status){
        this.rewardsSlides=res.banners

      }
    },err=>{
        console.log(err)
    })
  }
  async openQRMODAL(){
    if(this.globals.isloggedIn==true){
      console.log(this.globals.isloggedIn)
    const modal = await this.modalController.create({
      component: UserQrPage,
      componentProps: { data: {} },
  
      backdropDismiss:true,
      cssClass:'QRModal',
      animated: true,
      swipeToClose: true,
      mode: 'ios',
      // handle: false,
      });
    
      await modal.present();
    }
    else{
      this.globals.loginmodal();
    }
  }
}
